import { EditProps } from "react-admin";
import { DefaultEdit } from "../../../lib/components";
import {
  MediaFileSource,
  transformAndUploadS3Files,
} from "../../../lib/modules";
import { CategoryForm } from "./CategoryForm";

const CategoryEdit= (props:EditProps) => {
  const mediaFileSources: MediaFileSource[] = [
    {
      source: "files",
      subFolder: "category",
    },
  ];

  return (
    <DefaultEdit
      {...props}
      mutationMode="pessimistic"
      transform={transformAndUploadS3Files(mediaFileSources)}
    >
      <CategoryForm isEdit={true}{...props} />
    </DefaultEdit>
  );
};

export { CategoryEdit };
